/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetDocumentationDto
 */
export interface GetDocumentationDto {
    /**
     * 
     * @type {string}
     * @memberof GetDocumentationDto
     */
    filename: string;
    /**
     * 
     * @type {string}
     * @memberof GetDocumentationDto
     */
    content: string;
}

/**
 * Check if a given object implements the GetDocumentationDto interface.
 */
export function instanceOfGetDocumentationDto(value: object): value is GetDocumentationDto {
    if (!('filename' in value) || value['filename'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function GetDocumentationDtoFromJSON(json: any): GetDocumentationDto {
    return GetDocumentationDtoFromJSONTyped(json, false);
}

export function GetDocumentationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDocumentationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'filename': json['filename'],
        'content': json['content'],
    };
}

export function GetDocumentationDtoToJSON(value?: GetDocumentationDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'filename': value['filename'],
        'content': value['content'],
    };
}

